/* SponsoredAppSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _15 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _14 = "._y3gn1h6o{text-align:center}";
const _13 = "._k48p1fw0{font-weight:700}";
const _12 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7e1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _11 = "._4cvr1h6o{align-items:center}";
const _10 = "._2lx21bp4{flex-direction:column}";
const _9 = "._1bah1h6o{justify-content:center}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _6 = "._k48p1nn1{font-weight:400}";
const _5 = "._1bsb1tad{width:21.25rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { media } from '@atlaskit/primitives';
import { AppTile, AppTileGridSkeleton, AppTilesGridContainer, AppTileSize } from '@atlassian/mpac-app-tile';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodyLarge, BodySmall, breakpointValues, ExternalLink, H3, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { RichTooltip } from '@atlassian/mpac-ui';
import { useEnvironment, useSource } from '@atlassian/mpac-utils';
import UFOLoadHold from '@atlassian/react-ufo/load-hold';
import React from 'react';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { SECTIONS } from '../../hooks/useHomepageAnalytics/constants';
import { TEST_IDS } from '../../testids';
import { Description, RegularSectionSkeleton, SectionHeader } from '../RegularSection';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "._1m7t1txw>h2{display:flex}";
const _3 = "._i0dl1n8h{flex-basis:70%}";
const _2 = "._1o9zkb7n{flex-shrink:1}";
const _ = "._16jlkb7n{flex-grow:1}";
const HeaderDetails = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dl1n8h _1m7t1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderDetails.displayName = 'HeaderDetails';
}
const TooltipContent = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1tad _k48p1nn1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipContent.displayName = 'TooltipContent';
}
const SectionHeaderStyle = null;
const DescriptionStyle = null;
const H3Style = null;
export function SponsoredAppsSectionSkeleton(_ref3) {
  let {
    tileCount
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": TEST_IDS.SPONSORED_SECTION_SKELETON,
    children: /*#__PURE__*/_jsx(RegularSectionSkeleton, {
      hideDescription: true,
      hideShowMore: true,
      children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
        children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
          size: AppTileSize.MEDIUM,
          tileCount: tileCount
        })
      })
    })
  });
}

// eslint-disable-next-line max-lines-per-function
export function SponsoredAppSection(_ref4) {
  let {
    isLoading,
    isError,
    data
  } = _ref4;
  const source = useSource();
  const environment = useEnvironment();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  const {
    trackTileClick,
    trackHomeScreenErrorState
  } = useHomepageAnalytics();
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const handleTileClick = (app, title, index) => {
    const tileClickEventData = {
      app,
      sectionTitle: title,
      index,
      hideDescription: isMobile
    };
    trackTileClick(tileClickEventData);
  };
  if (isLoading) {
    const tileCount = isMobile ? 3 : isTablet ? 4 : 6;
    return /*#__PURE__*/_jsx(UFOLoadHold, {
      name: SECTIONS.SPONSORED,
      children: /*#__PURE__*/_jsx(SponsoredAppsSectionSkeleton, {
        tileCount: tileCount
      })
    });
  }
  if (isError) {
    trackHomeScreenErrorState(SECTIONS.SPONSORED);
    return /*#__PURE__*/_jsx(PartialOutageError, {});
  }
  if (data) {
    const {
      title,
      apps,
      description
    } = data;
    let appsToRender = apps;
    if (isMobile) {
      appsToRender = apps.slice(0, 3);
    } else if (isTablet) {
      appsToRender = apps.slice(0, 4);
    }
    if (enableMpacWebCoherence()) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8, _9, _10, _11, _12]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_zulpu2gc _1e0c1txw _1bah1h6o _2lx21bp4 _4cvr1h6o _1b7e1ejb"]),
            children: /*#__PURE__*/_jsx(HeaderDetails, {
              children: /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_13, _14]
                }), /*#__PURE__*/_jsxs(H3, {
                  as: "h2",
                  className: ax(["_k48p1fw0 _y3gn1h6o"]),
                  children: [title, description && /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_15, _6, _14]
                    }), /*#__PURE__*/_jsx(BodyLarge, {
                      "data-testid": "section-description",
                      className: ax(["_19pku2gc _k48p1nn1 _y3gn1h6o"]),
                      children: description
                    })]
                  }), /*#__PURE__*/_jsx(RichTooltip, {
                    content: /*#__PURE__*/_jsxs(TooltipContent, {
                      children: ["Apps in this listing are randomly selected from our", ' ', /*#__PURE__*/_jsx(ExternalLink, {
                        size: "small",
                        href: "https://www.atlassian.com/company/ventures",
                        children: "Atlassian Ventures program"
                      }), ", which invests in companies focusing on innovative cloud collaboration. These apps are not promoted based on any other specific parameters."]
                    }),
                    children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                      size: "medium",
                      label: ""
                    })
                  })]
                })]
              })
            })
          })]
        }), /*#__PURE__*/_jsx(AppTilesGridContainer, {
          children: appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
            tileData: app,
            environment: environment,
            source: source,
            hideTagline: true,
            onTileClick: () => handleTileClick(app, title, index)
          }, app.addonKey))
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: /*#__PURE__*/_jsx(HeaderDetails, {
          children: /*#__PURE__*/_jsxs(H3, {
            as: "h2",
            children: [title, description && /*#__PURE__*/_jsx(Description, {
              "data-testid": "section-description",
              children: description
            }), /*#__PURE__*/_jsx(RichTooltip, {
              content: /*#__PURE__*/_jsxs(TooltipContent, {
                children: ["Apps in this listing are randomly selected from our", ' ', /*#__PURE__*/_jsx(ExternalLink, {
                  size: "small",
                  href: "https://www.atlassian.com/company/ventures",
                  children: "Atlassian Ventures program"
                }), ", which invests in companies focusing on innovative cloud collaboration. These apps are not promoted based on any other specific parameters."]
              }),
              children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                size: "medium",
                label: ""
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(AppTilesGridContainer, {
        children: appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
          tileData: app,
          environment: environment,
          source: source,
          hideTagline: true,
          onTileClick: () => handleTileClick(app, title, index)
        }, app.addonKey))
      })]
    });
  } else {
    return null;
  }
}